import { AppBar, Toolbar, Button, Container, Box } from '@mui/material';
import { Link as MuiLink } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useDeveloperInfo } from '../hooks/useApi';
import logoUrl from '../../assets/main_logo/Logotype Iktos W.svg?url';

const LOGO_HEIGHT_PX = 28;
const LOGO_CLEAR_PX = LOGO_HEIGHT_PX / 4;


export function Layout({ children }: { children: React.ReactNode }) {
  const { logout } = useAuth();
  const location = useLocation();
  const isDocs = location.pathname.startsWith('/docs');
  const { data } = useDeveloperInfo();
  const isAdmin = data?.user?.isAdmin === true;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static">
        <Toolbar
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr auto 1fr',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Box
            component="img"
            src={logoUrl}
            alt="Iktos"
            sx={{
              display: 'block',
              justifySelf: 'start',
              height: LOGO_HEIGHT_PX,
              width: 'auto',
              py: `${LOGO_CLEAR_PX}px`,
              px: `${LOGO_CLEAR_PX}px`,
              boxSizing: 'content-box',
            }}
          />
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
            <MuiLink
              component={Link}
              to="/"
              color="inherit"
              underline={location.pathname === '/' ? 'always' : 'none'}
            >
              Home
            </MuiLink>
            <MuiLink
              component={Link}
              to="/faq"
              color="inherit"
              underline={location.pathname === '/faq' ? 'always' : 'none'}
            >
              FAQ
            </MuiLink>
            <MuiLink
              component={Link}
              to="/docs"
              color="inherit"
              underline={location.pathname.startsWith('/docs') ? 'always' : 'none'}
            >
              Documentation
            </MuiLink>
            <MuiLink
              component={Link}
              to="/usage"
              color="inherit"
              underline={location.pathname === '/usage' ? 'always' : 'none'}
            >
              Usage
            </MuiLink>
            {isAdmin && (
              <MuiLink
                component={Link}
                to="/admin"
                color="inherit"
                underline={location.pathname.startsWith('/admin') ? 'always' : 'none'}
              >
                Admin
              </MuiLink>
            )}
          </Box>
          <Box sx={{ justifySelf: 'end', display: 'flex', alignItems: 'center' }}>
            <Button color="inherit" onClick={logout} sx={{ color: '#EEE5E5' }}>
              Logout
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      {isDocs ? (
        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', minHeight: 0, width: '100%' }}>
          {children}
        </Box>
      ) : (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4, flexGrow: 1 }}>
          {children}
        </Container>
      )}
    </Box>
  );
}
